import { MaterialTypeSchema } from "./recycling.type";


export interface OrderSchema {
  id: string;
  waste_type: string;
  amount: number;
  amount_unit: PickupOrderAmountUnit;
  organization_id: string;
  data: Record<string, any>;
  material_type_id: string;
  material_type: MaterialTypeSchema;
  status: string;
  created_at: string;
  updated_at: string;
  sale_amount: number;
  /** Present when API expands collection site on list/detail */
  collection_site_id?: string;
  collection_site?: {
    id: string;
    data?: Record<string, any>;
  };
}

export enum PickupOrderAmountUnit {
  KG = 'kg',
  TONS = 'tons',
  LBS = 'lbs',
  BAGS = 'bags',
  CARTONS = 'cartons',
  BOTTLES = 'bottles',
  PALLETS = 'pallets',
  CUBIC_YARDS = 'cubic_yards',
  CUBIC_METERS = 'cubic_meters',
  LITERS = 'liters',
  GALLONS = 'gallons'
}

export enum PickupOrderStatus {
  PENDING = 'pending',
  IN_TRANSIT = 'in_transit',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

/** Container fill level in `data.fill_level` — must match backend allowed values */
export enum PickupOrderFillLevel {
  FULL = 'FULL',
  THREE_QT_FULL = 'THREE_QT_FULL',
  HALF_FULL = 'HALF_FULL',
  QT_FULL = 'QT_FULL',
}

/**
 * Create pickup order — status is server-controlled; do not send status on create.
 * Backend should default new orders to `pending`.
 */
export interface CreatePickupOrderRequest {
  waste_type: string;
  organization_id: string;
  amount: number;
  amount_unit: PickupOrderAmountUnit;
  material_type_id: string;
  /** OPS create flow does not expose this; send `0` by default */
  sale_amount: number;
  data?: Record<string, any>;
}

/** @deprecated Prefer CreatePickupOrderRequest; legacy shape still used by some callers */
export interface OrderRequest extends CreatePickupOrderRequest {
  status?: PickupOrderStatus;
}

export interface UpdateOrderRequest {
  waste_type?: string;
  amount?: number;
  amount_unit?: PickupOrderAmountUnit;
  status?: PickupOrderStatus;
  material_type_id?: string;
  sale_amount?: number;
  data?: Record<string, any>;
}

export interface OrderQueryParams {
  organization_id: string;
  page?: number;
  limit?: number;
  sort_by?: string;
  sort_pickup_order?: 'asc' | 'desc';
  waste_type?: string;
  start_date?: string;
  end_date?: string;
  search?: string;
  status?: PickupOrderStatus | string;
}

export interface PickupOrderPagination {
  pickup_orders: OrderSchema[];
  total: number;
  page: number;
  limit: number;
}

export type PaginatedOrderResponse = PickupOrderPagination; 